import React, { Fragment, useEffect } from 'react';
import sad from '../../assets/images/other-images/sad.png';
import { Container, Media, Col, Row } from 'reactstrap';
import { BACK_TO_HOME_PAGE } from '../../constant';
import { getFromLocalStorage } from '../../hooks/useLocalStorage';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { checkLowWalletBalance } from '../../api';


const Error500 = () => {

  const TodayDate = moment(new Date()).format("YYYY-MM-DD");
  
      const lastLoginDetails = moment(getFromLocalStorage('user')?.lastLoginDetails?.created_at);
      const userLastLoginDetails = lastLoginDetails.format("YYYY-MM-DD");
      const wallet_closure_status = getFromLocalStorage('user')?.partnerInfo?.wallet_closure_status;
      const is_kyc_active = getFromLocalStorage('user')?.partnerInfo?.is_kyc_active;
      const is_KYC = getFromLocalStorage('user')?.partnerInfo?.is_kyc;
      // const dealer_first_login = getFromLocalStorage('user')?.partnerInfo?.dealer_first_login;
      const partnership_id = getFromLocalStorage('user')?.partnerInfo?.partnership_id;
      const COMPANY_MODULE = getFromLocalStorage("user")?.companyInfo?.module_id;
  
      const navigate = useNavigate()

  const redirectToDashboard = () => {
    window.location.href = '/dashboard/default'; // Redirects to the dashboard page

    let navigateUrl = `${process.env.PUBLIC_URL}/users/users`;
    
        if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") ) {
          // if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") && !dealer_first_login) {
          // navigate(navigateUrl);
          if (is_kyc_active != true) {
            // navigateUrl = `${process.env.PUBLIC_URL}/sales/policies/create-new/1`;
            navigateUrl = `${process.env.PUBLIC_URL}/documents/kyc`;
          } else {
            if(COMPANY_MODULE && COMPANY_MODULE == 2){
              // console.log("11111...........")
              navigateUrl = `${process.env.PUBLIC_URL}/sales/policies/create/1`;
            } else{
              // console.log("222222222...........")
              navigateUrl = `${process.env.PUBLIC_URL}/sales/policies/create-new/1`;
            }
          }
        // } else if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") && (userLastLoginDetails !== TodayDate)) {
        } else if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER")) {
          if (wallet_closure_status == "ACTIVE" && is_kyc_active == true && is_KYC == true) {
            checkLowWalletBalance(partnership_id)
              .then((res) => {
              }).catch((err) => {
                console.log("Something went wrong")
              });
            navigate(navigateUrl);
          }
        } else if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") && (userLastLoginDetails === TodayDate) || (getFromLocalStorage('ROLE')?.key == "CRM")) {
          if (wallet_closure_status == "ACTIVE" && is_kyc_active == true && is_KYC == true) {
            if(COMPANY_MODULE && COMPANY_MODULE == 2){
              // console.log("333333333...........")
              navigateUrl = `${process.env.PUBLIC_URL}/sales/policies`;
            } else{
              // console.log("44444444444...........")
              navigateUrl = `${process.env.PUBLIC_URL}/sales/policies/certificate`;
            }
            
            // navigateUrl = `${process.env.PUBLIC_URL}/sales/policies/create-new/1`;
          }
        } else if ((getFromLocalStorage('ROLE')?.key == "DEALER_SALES_PERSON") || (getFromLocalStorage('ROLE')?.key == "FINANCE")  || (getFromLocalStorage('ROLE')?.key == "HO")) {
          // navigateUrl = `${process.env.PUBLIC_URL}/sales/policies/certificate`;
          if(COMPANY_MODULE && COMPANY_MODULE == 2){
              // console.log("333333333...........")
              navigateUrl = `${process.env.PUBLIC_URL}/sales/policies`;
            } else{
              // console.log("44444444444...........")
              navigateUrl = `${process.env.PUBLIC_URL}/sales/policies/certificate`;
            }
        }
        navigate(navigateUrl);
        
  };
  useEffect(() => {
    redirectToDashboard();
  }, []);

  return (
    <Fragment>
      <div
        style={{
          color: '#444',
          margin: 0,
          fontFamily: 'Arial, Poppins, sans-serif',
          height: '100%',
          backgroundColor: '#fff',
        }}
      >
        <Container fluid style={{ minHeight: '100vh' }}>
          <Row className="justify-content-center align-items-center" style={{ height: '100vh' }}>
            <Col xs="12" md="8" className="text-center">
              <h1 style={{ margin: 0, fontSize: '150px', lineHeight: '150px', fontWeight: 'bold' }}>500</h1>
              <h2 style={{ marginTop: '20px', fontSize: '30px' }}>Not Found</h2>
              <p>
                The page you are attempting to reach is currently not available. This may be because the page does not
                exist or has been moved!
              </p>

              <a href="/dashboard/default" style={{ textDecoration: 'underline' }} onClick={redirectToDashboard}>
                Back to home page
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default Error500;
